<template>
    <newOnboardingLayout>

        <template #left>
            <div class="text-xl mt-8">
                Create a Free Account
            </div>

            <ul class="list-disc mt-2 pl-4 mb-2">
                <li>14 day trial</li>
                <li>50 free outgoing message credits</li>
                <li>Explore all features</li>
            </ul>
            <div class="lg:text-xs italic mb-8">
                * During your trial you will only be allowed to message up to {{ $page.props.trial_contact_limit }} contacts.
                <a href="https://textspot.io/resources/a2p-guide/#How_does_my_trial_work_if_I_have_not_been_A2P_verified"
                    target='_blank' class="text-blue-500 font-bold cursor-pointer">Learn why</a>.
            </div>

            <span class="text-white font-bold bg-blue-500 border rounded-full text-xs p-2 pl-4 pr-4">
                STEP 1
            </span>
            <div class="lg:mb-8 mt-4">Provide your name, email, password and verify your account with your personal phone
                number.</div>

            <div class="hidden lg:block">
                <span class="text-gray-500 font-bold text-gray-700 bg-gray-300 border rounded-full text-xs p-2 pl-4 pr-4">
                    STEP 2
                </span>
                <div class="mb-8 mt-4">Get access to TextSpot and try it out!</div>

                <span class="text-gray-500 font-bold text-gray-700 bg-gray-300 border rounded-full text-xs p-2 pl-4 pr-4">
                    STEP 3
                </span>
                <div class="mb-8 mt-4">
                    Upgrade your account to get your own phone number and start messaging your contacts.
                    <strong>Start for just $29 + a one time carrier registration fee of $19. Cancel anytime.</strong><br />

                    <a href="https://textspot.io/resources/30-day-money-back-guarantee-policy/" target='_blank'
                        class="text-blue-500 cursor-pointer font-bold">
                        Learn about our 30-day money-back guarantee.
                    </a>
                </div>
            </div>

        </template>

        <template #center>
            <form @submit.prevent="submitForm">
                <div v-if="status == 'sent_code'">
                    <div class="mt-4">
                        <label class="block font-medium text-sm text-gray-700">
                            Please enter the code sent to {{ form.phone }}
                        </label>
                        <input v-model='form.code' class="form-input rounded-md shadow-sm block mt-1 w-full" type="input" value="" required="required" placeholder="1234">
                        <div v-if="error_message" class="bg-red-100 border border-red-400 text-red-700  p-2 mt-2 mb-2">
                            {{ error_message }}
                        </div>
                        <div class="flex items-center justify-end mt-4">
                            <jet-button :loading="loading">
                                CONTINUE
                            </jet-button>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <input type="hidden" name="_token" value="UEU1D2Tsz3N1kG33Hj6pJrRgOn6SDzh7JxGk0VXH">
                    <input type="hidden" class="g-recaptcha" name="recaptcha_token" id="recaptcha_token">
                    <div>
                        <label class="block font-medium text-sm text-gray-700">
                        Name
                    </label>
                        <input  v-model='form.name' class="form-input rounded-md shadow-sm block mt-1 w-full" type="text" name="name" required="required" autofocus="autofocus" autocomplete="name" placeholder="Johnny Appleseed">
                    </div>

                    <div class="mt-4">
                        <label class="block font-medium text-sm text-gray-700">
                                Email
                            </label>
                        <input v-model='form.email' class="form-input rounded-md shadow-sm block mt-1 w-full" type="email" name="email" value="" required="required" placeholder="johnny@apples-r-us.com">
                        <div v-if="email_errors" class="bg-red-100 border border-red-400 text-red-700 p-2 mt-2 text-sm">
                            {{ email_errors }}
                        </div>
                    </div>

                    <div class="mt-4">
                        <label class="block font-medium text-sm text-gray-700">
                            Phone Number
                        </label>
                        <maz-phone-number-input
                            id="phone-number"
                            v-model="form.phone"
                            :only-countries="['US']"
                            :required="true"
                            @update="phoneNumberUpdate"
                        />
                        <p class="text-xs text-gray-500">We will send you a text message to verify your account. VoIP numbers are not permitted.</p>
                        <p class="text-xs text-gray-500">By submitting your phone number, you are authorizing us (opting in) to send you text messages and notifications.</p>
                        <div v-if="phone_errors" class="bg-red-100 border border-red-400 text-red-700 p-2 mt-2 text-sm">
                            {{ phone_errors }}
                        </div>
                    </div>

                    <div class="mt-4">
                            <label class="block font-medium text-sm text-gray-700">
                            Password
                        </label>
                            <input v-model="form.password" class="form-input rounded-md shadow-sm block mt-1 w-full" type="password" name="password" required="required" autocomplete="new-password">
                        <p class="text-xs text-gray-500">Must be at least 8 characters long</p>
                    </div>

                    <div class="mt-4">
                        <label class="block font-medium text-sm text-gray-700">
                                    Confirm Password
                                </label>
                        <input v-model="form.password_confirmation" class="form-input rounded-md shadow-sm block mt-1 w-full" type="password" name="password_confirmation" required="required" autocomplete="new-password">
                    </div>

                    <div class="mt-4 flex">
                        <label class="block font-medium text-sm text-gray-700">
                            <input required type="checkbox" id="agree_to_terms" name="agree_to_terms" v-model="form.agree_to_terms">
                            I agree to TextSpot's <a href="https://textspot.io/terms/" target="_blank" class="underline">Terms of Service and Use</a> and <a href="https://textspot.io/anti-spam-policy/" target="_blank" class="underline">Anti-Spam Policy</a>
                        </label>
                    </div>
                    <div v-if="errors.message" class="bg-red-100 border border-red-400 text-red-700  p-2 mt-2 mb-2">
                        {{ errors.message }}
                    </div>
                    <div class="flex items-center justify-end mt-4">
                        <jet-button :loading="loading">
                            CREATE ACCOUNT
                        </jet-button>
                    </div>
                </div>
            </form>
        </template>
    </newOnboardingLayout>
</template>


<script>
import ApplicationMark from "../../Jetstream/ApplicationMark";
import JetButton from "../../Jetstream/Button";
import newOnboardingLayout from "../../Layouts/NewOnboardingLayout";

export default {
    name: 'registerPage',
    components: {
        ApplicationMark, 
        //VuePhoneNumberInput,
        JetButton, newOnboardingLayout,
    },
    data: () => ({
         form: {
            phone: '',
            agree_to_terms: '',
            password: '',
            password_confirmation: '',
            name: '',
            csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
            code: '',
            action: 'register',
        },
        loading: false,
        errors: {},
        error_message: "",
        status: 'good_to_onboard',
        showPhoneNumberValidationError: false,
    }),
    computed: {
        email_errors() {
            if (this.errors.email && this.errors.email.length) {
                return this.errors.email[0];
            }
        },
        phone_errors() {
            if (this.errors.phone && this.errors.phone.length) {
                return this.errors.phone[0];
            }
        },
    },
    methods: {
        submitForm() {

            this.loading = true;
            this.errors = {};
            this.error_message = "";
            axios.post(route('newRegistration'), this.form)
            .then(response => {
                this.loading = false;

                if (response.data.status === 'sent_code') {
                    this.status = 'sent_code';
                    this.form.action = 'check_code';
                    try {
                      window.dataLayer.push({
                        event: "sent-otp"
                      });
                    } catch (e) {}
                    return;
                }
                if (response.data.status == 'good_to_onboard') {
                    try {
                      window.dataLayer.push({
                        event: "completed-otp"
                      });
                    } catch (e) {}
                    window.location.href = route('newOnboarding');
                }
            })
            .catch(error => {
                this.loading = false;
                if (error.response.status === 419) {
                    this.error_message = "Form is expired";
                } else {
                    this.errors = error.response.data.errors;
                    if (error.response.data.message) {
                        this.error_message = error.response.data.message;
                    } else if (error.response.data.errors.message) {
                        this.error_message = error.response.data.errors.message;
                    }
                    //check if message is an array...
                    if (Array.isArray(this.error_message)) {
                        this.error_message = this.error_message[0];
                    }
                }
            });

        },
        phoneNumberUpdate(val) {
        },

    }
}
</script>


<style scoped>

</style>
